(function () {
  var hasMouse = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (!hasMouse) return;

  var containers = document.querySelectorAll('.cursor-trail');

  containers.forEach(function (container) {
    var sources = Array.prototype.slice.call(
      container.querySelectorAll('[data-trail-src]')
    ).map(function (img) { return img.getAttribute('src'); });

    if (sources.length === 0) return;

    var spawnInterval = parseInt(container.dataset.spawnInterval, 10) || 60;
    var fadeDuration = parseInt(container.dataset.fadeDuration, 10) || 700;
    var itemSize = parseInt(container.dataset.itemSize, 10) || 28;
    var maxItems = parseInt(container.dataset.maxItems, 10) || 40;

    var activeItems = [];
    var lastSpawn = 0;

    function spawn(x, y) {
      if (activeItems.length >= maxItems) {
        var oldest = activeItems.shift();
        if (oldest && oldest.parentNode) oldest.parentNode.removeChild(oldest);
      }

      var src = sources[Math.floor(Math.random() * sources.length)];
      var rotation = (Math.random() - 0.5) * 60;

      var el = document.createElement('img');
      el.src = src;
      el.alt = '';
      el.className = 'cursor-trail__item';
      el.style.width = itemSize + 'px';
      el.style.height = itemSize + 'px';
      el.style.objectFit = 'contain';
      el.style.transform = 'translate(-50%, -50%) rotate(' + rotation + 'deg)';
      el.style.transitionDuration = fadeDuration + 'ms';
      el.style.setProperty('--trail-rotation', rotation + 'deg');
      el.style.left = x + 'px';
      el.style.top = y + 'px';

      container.appendChild(el);
      activeItems.push(el);

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          el.classList.add('cursor-trail__item--fading');
        });
      });

      setTimeout(function () {
        if (el.parentNode) el.parentNode.removeChild(el);
        var idx = activeItems.indexOf(el);
        if (idx !== -1) activeItems.splice(idx, 1);
      }, fadeDuration + 50);
    }

    document.addEventListener('mousemove', function (e) {
      var now = performance.now();
      if (now - lastSpawn < spawnInterval) return;
      lastSpawn = now;
      spawn(e.clientX, e.clientY);
    });
  });
})();